export const TOKEN_KEY = "token";
export const GRAPHNAME = "graphName";
export const REFRESH_TOKEN_KEY = "refreshToken";
export const CHECK_BOX_VALUE = "checkboxValue";
export const CHECK_BOX_VALUES = "checkboxValues";
